<template>
  <!--prettier-ignore-->
  <div class="bg-secondary-500 py-2 text-center text-white text-xs">
    You are browsing as a <strong>Mentee</strong>.
    <button @click="switchActor" class="underline decoration-dashed underline-offset-2 rounded-md p-0.5 -m-0.5 focus:outline-none focus-visible:ring focus:ring-neutral-200">Switch to Mentor here</button>
  </div>
</template>

<script setup>
import { router } from '@inertiajs/vue3'

const switchActor = () => {
  router.patch('/switch-actor')
}
</script>
